export default __webpack_public_path__ + "static/media/DonorAdvisedFunds.23302e75.png";